<template>
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
  >
    <path d="M0.905775 11.5926C0.0270959 10.7139 0.0270947 9.28931 0.905775 8.41063L8.65739 0.65901C9.53607 -0.219669 10.9607 -0.21967 11.8394 0.65901L19.591 8.41063C20.4697 9.28931 20.4697 10.7139 19.591 11.5926L11.8394 19.3442C10.9607 20.2229 9.53607 20.2229 8.65739 19.3442L0.905775 11.5926ZM1.96643 9.47129C1.67354 9.76418 1.67354 10.2391 1.96644 10.5319L9.71805 18.2836C10.0109 18.5765 10.4858 18.5765 10.7787 18.2836L18.5303 10.5319C18.8232 10.2391 18.8232 9.76418 18.5303 9.47129L10.7787 1.71967C10.4858 1.42678 10.0109 1.42678 9.71805 1.71967L1.96643 9.47129Z" />
  </svg>
</template>
